import { useParams } from 'react-router-dom';

/**
 * Ensures all route params returned by useParams() are present and typed as strings.
 * React Router v6/v7 types params as string | undefined, even for required params.
 * This hook filters out undefined values and provides a strongly‑typed result.
 */
export function useRequiredParams<T extends Record<string, string>>() {
  const params = useParams();
  const result: Record<string, string> = {};

  for (const key in params) {
    const value = params[key];

    if (value === undefined) {
      throw new Error(`Missing required route param: "${key}"`);
    }

    result[key] = value;
  }

  return result as T;
}
